export const MESSAGE_ERREUR_CHAMP_OBLIGATOIRE = "Champ obligatoire";
export const MESSAGE_ERREUR_SAISIE_INCORRECTE = "Saisie incorrecte";

//schema moncompte
export const MESSAGE_ERREUR_IDCIVILITE_OBLIGATOIRE = "Civilité obligatoire";
export const MESSAGE_ERREUR_IDTYPECOMPTE_OBLIGATOIRE = "Type de compte obligatoire";
export const MESSAGE_ERREUR_SOCIETE_OBLIGATOIRE = "Société obligatoire";

export const MESSAGE_ERREUR_NOM_OBLIGATOIRE = "Le nom est obligatoire";
export const MESSAGE_ERREUR_PRENOM_OBLIGATOIRE = "Le prénom est obligatoire";
export const MESSAGE_ERREUR_EMAIL_OBLIGATOIRE = "L'email est obligatoire";
export const MESSAGE_ERREUR_EMAIL_FORMAT = "Email , format incorrect";
export const MESSAGE_ERREUR_TELEPHONE_OBLIGATOIRE = "Le téléphone est obligatoire";
export const MESSAGE_ERREUR_REGEXP_TELEPHONE = "Le téléphone est obligatoire et doit être au format international (ex: +33123456789)";
//export const MESSAGE_ERREUR_MIN_TELEPHONE = "Au moins un numéro de téléphone doit être fourni";
//export const MESSAGE_ERREUR_REGEXP_TELEPHONE_INDICATIF = "Ex +33";
export const MESSAGE_ERREUR_CONFIRMATION_EMAIL_OBLIGATOIRE = "Confirmation Email obligatoire !";
export const MESSAGE_ERREUR_CONFIRMATION_EMAIL_FORMAT = "Confirmation Email , format incorrect";
export const MESSAGE_ERREUR_CONFIRMATION_EMAIL_NON_CORRESPONDANT = "Les emails ne correspondent pas";
export const MESSAGE_ERREUR_EMAILNEW_EMAIL_IDENTIQUES = "Les deux Emails sont égaux";
export const MESSAGE_ERREUR_SITEINTERNET_FORMAT = "Site Internet , format incorrect";

//schema mon organisation
export const MESSAGE_ERREUR_SIREN_OBLIGATOIRE = "Siren obligatoire";
export const MESSAGE_ERREUR_SIREN_FORMAT = "Le SIREN doit contenir exactement 9 chiffres";
export const MESSAGE_ERREUR_SECTEURACTIVITE_OBLIGATOIRE = "Secteur d'activité obligatoire";
export const MESSAGE_ERREUR_TYPECOMPTESOCIETE_OBLIGATOIRE = "Type compte société obligatoire";
export const MESSAGE_ERREUR_TYPESECTEURACTIVITE_OBLIGATOIRE = "Type Secteur Activite obligatoire";
export const MESSAGE_ERREUR_SITEINTERNET_OBLIGATOIRE = "Site Internet Societe obligatoire";
export const MESSAGE_ERREUR_NOMSOCIETE_OBLIGATOIRE = "Nom obligatoire";
export const MESSAGE_ERREUR_ADRESSE_OBLIGATOIRE = "Adresse est obligatoire";
export const MESSAGE_ERREUR_CODEPOSTAL_OBLIGATOIRE = "CodePostal est obligatoire";
export const MESSAGE_ERREUR_VILLE_OBLIGATOIRE = "Ville est obligatoire";
export const MESSAGE_ERREUR_PAYS_OBLIGATOIRE = "Pays est obligatoire";


//schema adresse
// export const MESSAGE_ERREUR_ADRESSE_OBLIGATOIRE = "Adresse obligatoire";
// export const MESSAGE_ERREUR_CODE_POSTAL_OBLIGATOIRE = "Code postal obligatoire";
// export const MESSAGE_ERREUR_VILLE_OBLIGATOIRE = "Ville obligatoire";
// export const MESSAGE_ERREUR_PAYS_OBLIGATOIRE = "Choix du pays obligatoire";
// export const MESSAGE_ERREUR_NOM_VOIE_OBLIGATOIRE = "Nom de voie obligatoire";
// export const MESSAGE_ERREUR_CODE_POSTAL_TAILLLE = "Le code postal doit contenir 5 chiffres";
// export const MESSAGE_ERREUR_CODE_POSTAL_NUMERIQUE = "Valeurs numériques uniquement";

//Schema Message
export const MESSAGE_ERREUR_TYPEDEMANDE_OBLIGATOIRE = "Type de demande obligatoire";
export const MESSAGE_ERREUR_MESSAGEDEMANDE_OBLIGATOIRE = "message demande obligatoire";
export const MESSAGE_ERREUR_TYPEREPONSE_OBLIGATOIRE = "Type de reponse obligatoire";
export const MESSAGE_ERREUR_MESSAGEREPONSE_OBLIGATOIRE = "message reponse obligatoire";

export const MESSAGE_ERREUR_3CARACTERES_MINIMUM = "Le champ doit contenir au moins 3 caractères";

//schema mot de passe
export const MESSAGE_ERREUR_MDP_OBLIGATOIRE = "Mot de passe obligatoire !";
export const MESSAGE_ERREUR_MDP_FORMAT =
  "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial";
export const MESSAGE_ERREUR_CONFIRMATION_MDP_OBLIGATOIRE =
  "Confirmation Mot de passe obligatoire !";
export const MESSAGE_ERREUR_MDP_NON_CORRESPONDANT =
  "Les mots de passe ne correspondent pas";

//schema CGU
export const MESSAGE_CGU_OBLIGATOIRE = "Les CGU/CGV doivent être acceptées";


